export default {
    appName: "Designshark LLC",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.designsharkllc.com' : 'http://127.0.0.1:8000',
    localUserKey: "yhjcbjmvlyinnkhxhxywxtpurkz"
}
